import { EstimateurBudgetSelection } from '@components/estimateur-budget-selection/models';
import { Block } from '@shared/models';

export const estimateurBudgetSelectionMock: Block<EstimateurBudgetSelection> = {
  type: 'estimateur-budget-selection',
  data: {
    gtmConfigCreateEstimate: {
      event: 'click_cta_estimation_new',
      group: 'estimation',
      description: 'recap estimation',
      context: 'click bouton nouvelle estimation tunnel estimation',
    },
    gtmConfigSendEstimateByEmail: {
      event: 'click_cta_estimation_email',
      group: 'estimation',
      description: 'recap estimation',
      context: 'click bouton nouvelle estimation tunnel estimation',
    },
    gtmConfigEstimateEmailSent: {
      event: 'click_cta_estimation_dl',
      group: 'estimation',
      description: 'recap estimation',
      context: "Téléchargement de l'estimation avec prise de coordonnées",
    },
    gtmConfigEditButton: {
      event: 'click_cta_estimation_modif',
      group: 'estimation',
      description: 'recap estimation',
      context: 'modification de la sélection', // "modification de la sélection {{objet}}" - Note: {{objet}} will be populated dynamically by the frontend
    },
  },
};
